import { render, staticRenderFns } from "./ConfigurarPantallaMotivo.vue?vue&type=template&id=0b499f21&"
import script from "./ConfigurarPantallaMotivo.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarPantallaMotivo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarPantallaMotivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b499f21', component.options)
    } else {
      api.reload('0b499f21', component.options)
    }
    module.hot.accept("./ConfigurarPantallaMotivo.vue?vue&type=template&id=0b499f21&", function () {
      api.rerender('0b499f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MotivodeBaja/ConfigurarPantallaMotivo.vue"
export default component.exports